/** Placeholder rows while a usage list loads. */
export function SkeletonRows({ columns }: { columns: number }) {
  return (
    <>
      {Array.from({ length: 6 }, (_, i) => (
        <tr key={i} className="skeleton-row" aria-hidden="true">
          {Array.from({ length: columns }, (__, c) => (
            <td key={c}><span className="skeleton-bar" /></td>
          ))}
        </tr>
      ))}
    </>
  );
}
